export default "__VITE_PUBLIC_ASSET__978e8e9a__"